import { SortBy, SortOrder } from "@/common/enum";
import Shared from "@/common/shared";

export default class SortParameters {
  public sortBy!: SortBy;
  public sortOrder!: SortOrder;

  constructor() {
    this.sortBy = Shared.defaultSortBy;
    this.sortOrder = Shared.defaultSortOrder;
  }
}
